import { useState } from "react" 
import { IPrimitiveProps } from "../section/Primitive"
import { Gallery, Gallery1, Gallery2, Gallery3, Gallery4, Gallery5, Gallery6 } from "src/modules/pe-basic-module/views/diary/ThumbnailTile"
import GalleryDialog from "src/modules/pe-basic-module/views/gallery/GalleryDialog" 
import { ThumbnailTileContent } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */ 
const ThumbnailTilePrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: ThumbnailTileContent = props.primitive as ThumbnailTileContent  
     
    const [isOpen, setIsOpen] = useState( false )
        const [i, setI] = useState(0) 
        const gallery = [ ...primitive.images! ] 
        const to = (i :number) => {
            setI(i)
            setIsOpen( true )
        }
        let _gallery : JSX.Element
        switch(gallery.length)
        {
            case 0:
                _gallery = <></>
                break
            case 1:
                _gallery = <Gallery1 gallery={gallery}  to={to} start={0} animated={primitive.animated}  animated_delay={primitive.animated_delay} gap={primitive.gap} />
                break
            case 2:
                _gallery = <Gallery2 gallery={gallery}  to={to} start={0} animated={primitive.animated}  animated_delay={primitive.animated_delay} gap={primitive.gap} />
                break
            case 3:
                _gallery = <Gallery3 gallery={gallery}  to={to} start={0} animated={primitive.animated}  animated_delay={primitive.animated_delay} gap={primitive.gap} />
                break
            case 4:
                _gallery = <Gallery4 gallery={gallery}  to={to} start={0} animated={primitive.animated}  animated_delay={primitive.animated_delay} gap={primitive.gap} />
                break
            case 5:
                _gallery = <Gallery5 gallery={gallery}  to={to} start={0} animated={primitive.animated}  animated_delay={primitive.animated_delay} gap={primitive.gap} />
                break
            case 6:
                _gallery = <Gallery6 gallery={gallery}  to={to} start={0} animated={primitive.animated}  animated_delay={primitive.animated_delay} gap={primitive.gap} />
                break
            default:
                _gallery = <Gallery gallery={gallery}   to={to} start={0} animated={primitive.animated}  animated_delay={primitive.animated_delay} gap={primitive.gap} />
        }
        return <>
            { _gallery }
            <GalleryDialog
                i={ i }
                data={ gallery }
                setI={ setI }
                isOpen={ isOpen }
                setIsOpen={ setIsOpen }
            />
        </>
}
export default ThumbnailTilePrimitive